<template>
  <div class="container">
    <div class="description">
      <md-field md-clearable>
        <label>説明</label>
        <md-input v-model="_Description" required maxlength="50"></md-input>
      </md-field>
    </div>

    <!-- 現状はBiZOOPeフォーマットのみなので選択肢は非表示にします -->
    <div hidden class="type">
      <div class="title">
        <gl-sub-text>タイプ（フォーマット）</gl-sub-text>
      </div>

      <md-radio v-model="_type" value="bizoope">
        BiZOOPeオリジナル
      </md-radio>
      <md-radio v-model="_type" value="tana-power">
        棚POWER互換
      </md-radio>
      <!-- <md-radio v-model="_type" value="store-manager" :disabled="true">
        StoreManager互換
      </md-radio> -->
    </div>

    <div class="groupKeys">
      <div class="title">
        <gl-sub-text>集計キー</gl-sub-text>
      </div>
      <md-checkbox v-model="groupKeys" value="term">期間別</md-checkbox>
      <md-checkbox v-model="groupKeys" value="item">商品別</md-checkbox>
      <md-checkbox v-model="groupKeys" value="store">店舗別</md-checkbox>
    </div>

    <div class="optionalDownloads" v-if="_type === 'bizoope'">
      <div class="title">
        <gl-sub-text>追加ダウンロード</gl-sub-text>
      </div>
      <md-checkbox v-model="optionalDownloads" value="receipt_count"
        >客数データ</md-checkbox
      >
      <md-checkbox v-model="optionalDownloads" value="item"
        >商品マスタ</md-checkbox
      >
      <md-checkbox v-model="optionalDownloads" value="store"
        >店舗マスタ</md-checkbox
      >
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 店舗（任意複数）選択コンポーネント
 */
export default {
  components: {},
  mixins: [ErrorReport],
  props: {
    /**
     * 説明
     */
    description: {
      type: String,
    },
    availableDataTypes: {
      type: Array,
    },
    /**
     * 選択しているジャーナルタイプ
     */
    type: {
      type: String,
    },
    /**
     * 選択している集計キー
     */
    groupKeys: {
      type: Array,
      default: () => ['term', 'item', 'store'],
    },
    /**
     * 選択している追加ダウンロード
     */
    optionalDownloads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /**
       * 店舗グループマスタ
       */
      storeGroups: [],
      /**
       * 店舗ツリー描画用データ
       */
      treeEntries: [],
    }
  },
  watch: {},
  computed: {
    _type: {
      get() {
        return this.type
      },
      set(newVal) {
        this.$emit('update:type', newVal)
      },
    },
    canUsePos() {
      if (this.availableDataTypes) {
        return this.availableDataTypes.includes('pos')
      } else {
        return false
      }
    },
    canUseIdPos() {
      if (this.availableDataTypes) {
        return this.availableDataTypes.includes('idpos')
      } else {
        return false
      }
    },
    errors() {
      const errors = []

      if (!this.description) {
        errors.push('説明を入力してください')
      }

      if (this.groupKeys.length === 0) {
        errors.push('集計キーを選択してください')
      }

      return errors
    },
    _Description: {
      get() {
        return this.description
      },
      set(newVal) {
        this.$emit('update:description', newVal)
      },
    },
  },
  async mounted() {},
}
</script>
